import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ClockInModalData {
  shiftId: string;
  facilityName: string;
  shiftStartTime?: string;
}

@Injectable({ providedIn: 'root' })
export class ClockInModalService {
  private readonly _open$ = new Subject<ClockInModalData>();
  private readonly _closed$ = new Subject<'clockedIn' | 'dismissed'>();

  /** Emits when the modal should be opened with the given data. */
  readonly open$ = this._open$.asObservable();

  /** Emits when the modal has been closed after an action. */
  readonly closed$ = this._closed$.asObservable();

  /** Request the layout to open the Clock In modal. */
  open(data: ClockInModalData): void {
    this._open$.next(data);
  }

  /** Notify subscribers that the modal was closed after an action. */
  notifyClosed(action: 'clockedIn' | 'dismissed'): void {
    this._closed$.next(action);
  }
}
